<template>
  <v-dialog v-model="dialog" width="1050" persistent>
    <v-card>
      <v-card-title>
        <h3><strong>{{ $t('shippingCorrectDialog.label.title') }}</strong></h3>
      </v-card-title>

      <v-card-text class="pa-4 pre-line grey--text text--darken-4 text-subtitle-1 px-5">
        <p class="mb-4">
          {{ $t('shippingCorrectDialog.message.main') }}
        </p>
        <v-row>
          <v-col cols="12">
            <v-text-field density="compact" variant="outlined" hide-details="auto" v-model="staffCode"
              :label="$t('shippingCorrectDialog.label.staffCode')" :counter="staffCodeLength"
              :maxLength="staffCodeLength" :disabled="isLoading" :rules="[rules.checkStaffCode]" />
          </v-col>
        </v-row>
      </v-card-text>
      <v-row>
        <v-col cols="12">
          <v-table density="compact" class="text-no-wrap">
            <thead>
              <tr>
                <th v-for="header in headers" :key="header">
                  {{ $t("shippingCorrectDialog.label.table." + header) }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="data in filteredDataList" :key="data">
                <template v-for="header in headers" :key="header">
                  <td>{{ data[header] }}</td>
                </template>
              </tr>
            </tbody>
          </v-table>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn text @click="this.handleClose(false)" :disabled="isLoading"> {{ $t('common.action.cancel') }} </v-btn>
        <v-btn color="indigo darken-1" dark @click="register" :loading="isLoading" :disabled="invalidInput">
          {{ $t('common.action.ok') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <MessageDialog v-if="messageDialogVisible" :dialog-data="messageDialogData" :handle-ok="closeMessageDialog" />
</template>

<script>
import api from "@/apis/staff";
import constant from "@/utils/constant"
import store from "@/store";
import utils from "@/utils";
import MessageDialog from "@/components/dialog/MessageDialog";

export default {
  components: { MessageDialog },
  props: {
    dialogData: {
      type: Object,
      required: true,
    },
    handleClose: {
      type: Function,
      required: true,
    },
  },
  computed: {
    invalidInput() {
      if (!utils.isValidStaffCode(this.staffCode)) return true;
      if ((this.staffCode.length > 0 && this.staffCode.length <= this.staffCodeLength)) return false;
      return true;
    },
    headers() {
      return this.$getTableDef("ShippingCorrectDialog");
    },
    filteredDataList() {
      return this.dialogData.correctList.slice();
    },
  },
  data() {
    return {
      dialog: true,
      staffCode: "",
      staffCodeLength: 0,
      isLoading: false,
      rules: {
        checkStaffCode: v => {
          return utils.isValidStaffCode(v) || this.$t('shippingCorrectDialog.validation.halfAlnum');
        },
      },
      // 汎用メッセージダイアログ
      messageDialogVisible: false,
      messageDialogData: {
        message: "",
        errorList: [],
      },
    };
  },
  methods: {
    /** メッセージの表示 */
    showMessage(message) {
      this.messageDialogData.message = message;
      this.messageDialogVisible = true;
    },
    /** リクエスト作成 */
    makeRequest() {
      const janList = [];
      for (const e of this.dialogData.correctList) {
        janList.push({
          janCode: e.janCode,
          suuryo: e.adjustmentQuantity - e.actualSuuryo,
        });
      }
      return {
        denpyoNumber: store.getShukkaDenpyoNumber(),
        staffId: this.staffCode,
        janList: janList,
      };
    },
    /** API実行 */
    async register() {
      this.isLoading = true;
      let message = this.$t('shippingDeleteDialog.message.success');
      try {
        const response = await api.post("/shukka/correct/register-actual", this.makeRequest());
        // 基本的に入力エラーは発生せず、整合性エラーが発生する
        // 汎用的なエラーメッセージを出した後、実績画面で再検索させることでエラーを解消させる
        if (response.data?.status != 0) throw "";
      } catch (e) {
        message = this.$t('common.message.errorAndRetry');
      } finally {
        this.isLoading = false;
      }
      this.showMessage(message);
    },
    /** 成功メッセージダイアログを閉じる */
    closeMessageDialog() {
      this.messageDialogVisible = false;
      this.handleClose(true);
    },
  },
  mounted() {
    this.staffCodeLength = constant.STAFF_CODE_MAX_LENGTH;
  },
};
</script>
<style>
.pre-line {
  white-space: pre-line;
}
</style>
